export default "__VITE_ASSET__CVRStakk__"